const bodyType = [
  {
    value: 'coupe',
    label: 'COUPE',
  },
  {
    value: 'compact',
    label: 'COMPACT',
  },
  {
    value: 'convertible',
    label: 'CONVERTIBLE',
  },
  {
    value: 'van',
    label: 'VAN',
  },
  {
    value: 'hatchback',
    label: 'HATCHBACK'
  },
  {
    value: 'suv',
    label: 'SUV'
  },
  {
    value: 'limousine',
    label: 'LIMOUSINE',
  },
  {
    value: 'station_wagon',
    label: 'STATION_WAGON'
  },
  {
    value: 'transporter',
    label: 'TRANSPORTER'
  }
];

export default bodyType;